import {
  AppBar, Badge, Button, colors, Dialog, DialogActions, DialogContent,
  DialogContentText, DialogTitle, IconButton, Toolbar, List, ListItem, ListItemText, ListItemIcon, Typography
} from '@material-ui/core';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { useTranslation } from 'react-i18next';
import { connect, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import NotificationsPopover from 'src/components/NotificationsPopover';
import SelectLanguage from 'src/components/SelectLanguage';
import { initNotifications } from 'src/modules/Notifications';
import { getNotifications, notifyNotificationViewed, readNotifications } from 'src/store/api/notificationsApi';
import { handleLogoutMain, publishLocation, getUser } from 'src/utils/Common';
import { baseURL, pushServerPublicKey } from 'src/utils/contants';
import { Link as RouterLink } from 'react-router-dom';
import { closeAlert, getTasksRequest } from '../../store/actions';
import { useOktaAuth } from '@okta/okta-react';
import axios from 'src/utils/axios';
import Flag from 'react-world-flags';
import logo from '../../assets/images/LogoTech.svg';
import notificationSound from '../../assets/media/mixkit-bell-notification-933.wav';
import WifiIcon from '@material-ui/icons/Wifi';
import WifiOffIcon from '@material-ui/icons/WifiOff';
import Tooltip from '@material-ui/core/Tooltip';
import Grid from '@material-ui/core/Grid'; // Grid bileşenini ekliyoruz
import HelpIcon from '@material-ui/icons/Help';
import TechGpt from 'src/components/TechGpt';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { createTheme } from '@material-ui/core/styles';
import TechGPTSVGIcon from '../../assets/images/chat-logo-techgpt-small.svg';


const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
  },
  flexGrow: {
    flexGrow: 1
  },
  title: {
    flexGrow: 1,
    marginBottom: theme.spacing(-1),
    marginLeft: theme.spacing(1)
  },
  search: {
    backgroundColor: 'rgba(255,255,255, 0.1)',
    borderRadius: 4,
    flexBasis: 300,
    height: 36,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: 'inherit'
  },
  searchInput: {
    flexGrow: 1,
    color: 'inherit',
    '& input::placeholder': {
      opacity: 1,
      color: 'inherit'
    }
  },
  searchPopper: {
    zIndex: theme.zIndex.appBar + 100
  },
  searchPopperContent: {
    marginTop: theme.spacing(1)
  },
  trialButton: {
    marginLeft: theme.spacing(2),
    color: theme.palette.common.white,
    backgroundColor: colors.green[600],
    '&:hover': {
      backgroundColor: colors.green[900]
    }
  },
  trialIcon: {
    marginRight: theme.spacing(1)
  },
  menuButton: {
    marginRight: theme.spacing(1)
  },

  chatButton: {
    marginLeft: theme.spacing(1)
  },
  notificationsButton: {
    marginLeft: theme.spacing(1)
  },
  notificationsBadge: {
    backgroundColor: colors.orange[600]
  },
  logoutButton: {
    [theme.breakpoints.up('lg')]: {
    marginLeft: theme.spacing(1),

    },
    [theme.breakpoints.down('xs')]: {
    },
  },
  logoutIcon: {
    marginRight: theme.spacing(1)
  }
}));

function TopBar({
  onOpenNavBarMobile,
  className,
  getTasksRequest,
  alertReducer,
  closeAlert
}) {
  const classes = useStyles();
  const { t } = useTranslation('common');
  const history = useHistory();
  const notificationsRef = useRef(null);
  const [notifications, setNotifications] = useState([]);
  const [notificationsLenght, setNotificationsLenght] = useState(0);
  const [showNotificationList, setShowNotificationList] = useState(false);
  const [CountryPopup, setCountryPopup] = useState(false);
  const [TenantData, setTenantData] = useState([]);
  const [loading, setloading] = useState(true);
  const SessionUser = getUser();
  const { oktaAuth } = useOktaAuth();
  const isOnline = useSelector(state => state.status?.isOnline);
  const isOnlineModeActive = useSelector(state => state.status?.isOnlineModeActive);
  const [isTechGptOpen, setIsTechGptOpen] = useState(false);
  const theme = createTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));



  // useEffect(() => {
  //   setIsOnline(onlineStatus);
  // }, [onlineStatus]);
  // const isAppSystemControl = process.env.REACT_APP_SYSTEM;

  // const handleClickNotification = ({ ID, Url }) => {
  //   setShowNotificationList(false);
  //   // notify server that was read
  //   notifyNotificationViewed(ID);
  //   getTasksRequest();
  //   if (Url.match(baseURL)) {
  //     history.push(Url.replace(baseURL, ''));
  //   } else {
  //     window.open(Url, '_blank');
  //   }
  //   // remove clicked notification
  //   setNotifications((notifications) => notifications.filter((notification) => notification.ID !== ID));
  // };

  useEffect(() => {
    FetchNotifications()
  }, []);

  useEffect(() => {
    // Component ilk kez yüklendiğinde ve her 5 dkda bir API'ye istek gönderme
    FetchNotifications();
    const intervalId = setInterval(FetchNotifications, 180000);

    // Component temizlendiğinde interval'i kaldırma
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  // const listenServiceWorker = () => {
  //   navigator.serviceWorker.addEventListener('message', (event) => {
  //     const { notification } = event.data;
  //     // add to notification list if new notification
  //     if (notification.action === 'ADD') {
  //       setNotifications((notifications) => [notification, ...notifications]);
  //     }
  //     // delete if user redirected from device notifications
  //     if (notification.action === 'DELETE' && notification.ID) {
  //       // in this case notified server by service worker
  //       setNotifications((notifications) => notifications.filter((ntf) => ntf.ID !== notification.ID));
  //     }

  //     if (notification.action === 'MUSTERI_IZLIYOR' && notification.ID) {
  //       setInterval(() => {
  //         publishLocation(notification.Title || 1);
  //       }, 10000);
  //     }
  //   });
  // };

  const handleToggleTechGpt = () => {
    // Custom event dispatch et
    window.dispatchEvent(new Event('toggleTechGpt'));
  };
  const fncsetCountryChange = () => {
    setloading(true);
    axios
      .get('/GetTenantMapData')
      .then(res => {
        const response = res.data;
        setloading(false);
        var sortedTenantMapData = response.sort((a, b) => a.Tenant.localeCompare(b.Tenant))
        setTenantData(sortedTenantMapData);
        setCountryPopup(true);
      })
      .catch(err => {
        setTenantData([]);
        setloading(false);
      });
  };

  const changeCountry = country => {
    setCountryPopup(false);
    confirmAlert({
      message: t('ChangingCoutryQuestion'),
      buttons: [
        {
          label: t('Evet'),
          onClick: () => changeCountryYes(country)
        },
        {
          label: t('Hayir'),
          onClick: () => {
            setCountryPopup(true);
          }
        }
      ]
    });
  };

  const changeCountryYes = country => {
    const data = {
      TechnicianId: SessionUser.TechnicianId,
      TenantId: country.TenantId,
      TenantCode: country.CountryCode
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };

    axios
      .post('/ChangeCountry', data, config)
      .then(response => {
        handleLogoutMain();
        sessionStorage.removeItem('SearhResult');
        sessionStorage.removeItem('ConsumerId');
        window.location.href = window.location.origin;
      })
      .catch(error => { });
  };

  // const handleDeleteAll = () => {
  //   setShowNotificationList(false);
  //   confirmAlert({
  //     message: t('bildirim_sil_confirm'),
  //     buttons: [
  //       {
  //         label: t('Evet'),
  //         onClick: () => deleteYes()
  //       },
  //       {
  //         label: t('Hayir'),
  //         onClick: () => { }
  //       }
  //     ]
  //   });
  //   const deleteYes = () => {
  //     notifications.forEach((e) => {
  //       notifyNotificationViewed(e.ID);
  //     });
  //     // getNotifications()
  //     //   .then(res => {
  //     //     res.data && setNotifications(res.data);
  //     //   })
  //     //   .catch(error => console.error(error));
  //   };
  // };

  const Logout = async () => {
    handleLogoutMain();
    await oktaAuth.signOut();
  };

  const ReadNotifications = () => {
    setShowNotificationList(false)
    const maxId = Math.max(...notifications.map(o => o.Id))
    readNotifications(SessionUser.TechnicianId, maxId);
    if (notifications !== undefined && notifications.length > 0) {
      const updatedList = notifications.map(n => {
        if (n.IsRead === false) {
          return { ...n, IsRead: true };
        }
        return n;
      });
      setNotifications(updatedList);
    }
    setNotificationsLenght(0);
  }

  const FetchNotifications = async () => {

    // get all new notifications from server
    getNotifications(SessionUser.TechnicianId)
      .then(res => {
        if (res.data.length > 0) {
          setNotifications(res.data);
          const unreadItems = res.data.filter(item => item.IsRead === false);
          setNotificationsLenght(unreadItems.length)

          if (unreadItems.length > 0) {
            playNotificationSound();
          }
        }
      })
      .catch(error => console.error(error));
  }

  const playNotificationSound = async () => {
    // play ding for new / unread notifications from server
    // const audioNotification = new Audio(notificationSound);
    // audioNotification.play();
  }


  const Beyaz = {
    color: '#FFFFFF'
  };
  const Red = {
    color: '#ff0000'
  };

  return (
    <AppBar
      className={clsx(classes.root, className)}
      style={{ background: '#1D3343' }}
    >
      <Toolbar>
      <Grid container alignItems="center" justifyContent="space-between">
        {/* Sol taraftaki butonlar */}
        <Grid item>
          <Grid container alignItems="center" spacing={1} wrap="nowrap">
            {!isXs && (
              <Grid item>
                <IconButton
                  className={classes.menuButton}
                  style={Beyaz}
                  onClick={onOpenNavBarMobile}
                  data-tour="OpenNavbarButton"
                >
                  <MenuIcon />
                </IconButton>
              </Grid>
            )}
            <Grid item>
              <RouterLink to="/overview" data-tour="SiriusButton">
                <img
                  height="48px"
                  width="100px"
                  alt="Logo"
                  src={logo}
                />
              </RouterLink>
            </Grid>
          </Grid>
        </Grid>

        {/* Sağ taraftaki butonlar */}
        <Grid item>
          <Grid container alignItems="center" justifyContent='space-between' spacing={1} wrap="nowrap">
            {isXs && (
              <Grid item>
                <IconButton
                  style={Beyaz}
                  onClick={onOpenNavBarMobile}
                  data-tour="OpenNavbarButton"
                >
                  <MenuIcon />
                </IconButton>
              </Grid>
            )}
            <Grid item>
              <IconButton
                
                style={Beyaz}
                onClick={handleToggleTechGpt}
              >
                <img 
                  src={TechGPTSVGIcon} 
                  alt="TechGPT" 
                  style={{ width: 40, height: 40 }} 
                />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton
                onClick={() => setShowNotificationList(true)}
                ref={notificationsRef}
              >
                <Badge
                  style={Beyaz}
                  badgeContent={notificationsLenght}
                >
                  <NotificationsActiveIcon style={{ color: 'white' }} />
                </Badge>
              </IconButton>
            </Grid>
            <Grid item>
              <SelectLanguage />
            </Grid>
            {isOnlineModeActive && (
              <Grid item>
                <Tooltip title={`${isOnline ? 'You are online' : 'You are offline'}`}>
                  <IconButton
                    className={classes.menuButton}
                    style={Beyaz}
                    data-tour="StatusButton"
                  >
                    {isOnline ? <WifiIcon /> : <WifiOffIcon />}
                  </IconButton>
                </Tooltip>
              </Grid>
            )}
            <Grid item>
              <IconButton
                
                onClick={fncsetCountryChange}
              >
                <Badge style={Beyaz}>
                  <Flag code={SessionUser.TenantCode} height="16" />
                </Badge>
              </IconButton>
            </Grid>
            
            <Grid item>
              <IconButton
                style={Beyaz}
                onClick={() => Logout()}
                data-tour="LogoutButton"
              >
                <ExitToAppIcon style={{ color: 'white' }} />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Toolbar>
      <NotificationsPopover
        anchorEl={notificationsRef.current}
        notifications={notifications}
        // onClickNotification={handleClickNotification}
        onClose={() => ReadNotifications()}
        open={showNotificationList}
      // handleDeleteAll={handleDeleteAll}
      />

      <Dialog
        open={CountryPopup}
        maxWidth="xs"
        fullWidth
        onClose={() => setCountryPopup(false)}
      >
        <DialogTitle color="primary">{t('lblChangeCountry')}</DialogTitle>
        <DialogContent dividers>
          <List
            component="nav"
            aria-labelledby="nested-list-subheader"
            className={classes.root}
          >
            {TenantData.map(item => (
              <ListItem
                button
                key={item.TenantId}
                onClick={() => changeCountry(item)}
              >
                <ListItemIcon>
                  <Flag code={item.CountryCode} height="16" />
                </ListItemIcon>
                <ListItemText primary={` ${item.Tenant}`} />
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCountryPopup(false)} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={alertReducer.open}
        onClose={() => closeAlert()}
      >
        <DialogTitle color="primary">{alertReducer.title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {alertReducer.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => closeAlert()}
            color="primary"
          >
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* <div style={{ position: 'absolute', bottom: 0, right: 20, fontSize: 15 }}>
        {isAppSystemControl}
      </div> */}
    </AppBar>
  );
}

TopBar.propTypes = {
  className: PropTypes.string,
  onOpenNavBarMobile: PropTypes.func
};

export default connect(
  (state) => ({ alertReducer: state.alertReducer }),
  {
    getTasksRequest, closeAlert
  }
)(TopBar);
